export const HR_COLUMNS = [
  { field: 'Name', header: 'Name', sortBy: 'FirstName', class: 'name-col' },
  { field: 'Email', header: 'Email' },
  { field: 'Mobile', header: 'Mobile' },
  { field: 'Experience', header: 'Experience' },
  // { field: 'Soft Skills', header: 'Soft Skills' },
  { field: 'action', header: 'Action', isExport: false }
];

export const JOB_DESIGNATION_COLUMNS = [
  { field: 'Designation', header: 'Designation', sortBy: 'Designation', class: 'text-no-wrap' },
  { field: 'action', header: 'Action', isExport: false }
];

export const JOB_DESCRIPTION_COLUMNS = [
  { field: 'Name', header: 'Name', sortBy: 'Title', class: 'text-no-wrap' },
  { field: 'Subject', header: 'Subject', class: 'text-no-wrap' },
  { field: 'action', header: 'Action', isExport: false }
];

export const INTERVIEWERS_COLUMNS = [
  { field: 'Name', header: 'Interviewer Name', sortBy: 'FirstName', class: 'name-col' },
  { field: 'Technical Skills', header: 'Technical skills' },
  { field: 'Practical', header: 'Taking Practical' },
  { field: 'PracticalAdmin', header: 'Practical Admin' },
  { field: 'Experience', header: 'Experience' },
  { field: 'action', header: 'Action', isExport: false }
];

export const HR_INTERVIEWERS_COLUMNS = [
  { field: 'Name', header: 'Interviewer Name', class: 'name-col', width: '20%' },
  { field: 'Technology', header: 'Technology', width: '40%' },
  { field: 'Practical', header: 'Taking Practical', width: '10%' },
  { field: 'PracticalAdmin', header: 'Practical Admin', width: '10%' },
  { field: 'Interviews Taken', header: 'Interviews Taken', width: '10%' },
  { field: 'Experience', header: 'Exp.', width: '10%' }
];

export const INTERVIEW_TECHNOLOGY_COLUMNS = [
  { field: 'Technology', header: 'Technology', sortBy: 'Technology' },
  { field: 'Color', header: 'Technology Color', isExport: false },
  { field: 'action', header: 'Action', isExport: false }
];

export const EMAIL_TEMPLATES_COLUMNS = [
  { field: 'Title', header: 'Title' },
  { field: 'Subject', header: 'Subject' },
  { field: 'action', header: 'Action' }
];

export const COMMON_PARAMS_COLUMNS = [
  { field: 'Name', header: 'Name' },
  { field: 'isGroup', header: 'Type' },
  { field: 'Parameters', header: 'Parameters' },
  { field: 'action', header: 'Action', isExport: false }
];
export const CANDIDATE_COLUMNS = [
  { field: 'CandidateName', header: 'Candidate Name', sortBy: 'FirstName', class: 'name-col' },
  { field: 'Technology', header: 'Technology' },
  { field: 'Experience', header: 'Experience' },
  { field: 'InterviewOfCandidate', header: 'Scheduled' },
  // { field: 'Mobile', header: 'Mobile' },
  { field: 'Resume', header: 'Resume', isExport: false },
  { field: 'HR', header: 'HR' },
  { field: 'Location', header: 'Location' },
  // { field: 'Company', header: 'Company' },
  { field: 'CallStatus', header: 'Status of call' },
  { field: 'action', header: 'Action', isExport: false }
];

export const JOBS_COLUMNS = [
  { field: 'JobTitle', header: 'JobTitle', class: 'name-col' },
  { field: 'AssignedHRs', header: 'Assigned HRs', isExport: false },
  { field: 'Technology', header: 'Technology' },
  { field: 'Skills', header: 'Skills' },
  { field: 'Experience', header: 'Experience' },
  { field: 'JobMode', header: 'Job Mode' },
  { field: 'action', header: 'Action' }
];

export const JOBS_APPLICATION_COLUMNS = [
  { field: 'CandidateName', header: 'Candidate Name', class: 'name-col' },
  { field: 'MatchEvaluation', header: 'Profile Match(%)', class: 'text-center' },
  { field: 'CandidateExperience', header: 'Candidate Exp.' },
  // { field: 'JobExperience', header: 'Applied Job Exp.' },
  { field: 'JobTitle', header: 'Job Title' },
  { field: 'Qualification', header: 'Qualification' },
  { field: 'CurrentCompany', header: 'Current Company' },
  { field: 'CurrentCTC', header: 'Current CTC' },
  { field: 'ExpectedCTC', header: 'Expected CTC' },
  { field: 'NoticePeriod', header: 'Notice Period' },
  { field: 'Resume', header: 'Resume' },
  { field: 'Status', header: 'Status' },
  { field: 'DateCreated', header: 'Applied Date', sortBy: 'DateCreated' },
  { field: 'action', header: 'Action' }
  // { expander: true, width: '30px' }
];

export const ADMIN_CONFIRM_CANDIDATE_COLUMNS = [
  { field: 'CandidateName', header: 'Candidate Name', sortBy: 'FirstName', class: 'name-col' },
  { field: 'Technology', header: 'Technology' },
  { field: 'Experience', header: 'Experience' },
  { field: 'Resume', header: 'Resume', isExport: false },
  { field: 'HRName', header: 'HR' },
  { field: 'Location', header: 'Location' },
  { field: 'CurrentCompany', header: 'Company Name' }
];
export const ADMIN_NOT_CONFIRM_CANDIDATE_COLUMNS = [
  { field: 'CandidateName', header: 'Candidate Name', sortBy: 'FirstName', class: 'name-col' },
  { field: 'Technology', header: 'Technology' },
  { field: 'Experience', header: 'Experience' },
  { field: 'Resume', header: 'Resume', isExport: false },
  { field: 'Location', header: 'Location' },
  { field: 'CurrentCompany', header: 'Company Name' }
];

export const INTERVIEW_COLUMNS = [
  { field: 'CandidateName', header: 'Candidate Name', sortBy: 'FirstName', class: 'name-col' },
  { field: 'Technology', header: 'Technology' },
  { field: 'HR', header: 'HR' },
  { field: 'Interviewer', header: 'Interviewer' },
  // { field: 'Company', header: 'Company' },
  { field: 'Status', header: 'Status', class: 'status' },
  { field: 'Result', header: 'Final Result' },
  { field: 'action', header: 'Action', isExport: false }
];
export const INTERVIEW_ROUND_COLUMNS = [
  { field: 'Interviewer Name', header: 'Interviewer Name', class: 'name-col' },
  {
    field: 'Start Date',
    header: 'Date',
    sortBy: 'StartDateOfInterviewRound',
    class: 'text-no-wrap'
  },
  { field: 'HR', header: 'HR' },
  { field: 'InterviewRound', header: 'Interview Round' },
  { field: 'InterviewRoundMode', header: 'Interview Round Mode' },
  { field: 'Status', header: 'Status', class: 'status' },
  { field: 'Result', header: 'Result' },
  { field: 'action', header: 'Action', isExport: false }
];

export const INTERVIEW_ROUND_SCHEDULE_DETAILS = [
  { field: 'Interviewer Name', header: 'Interviewer Name', class: 'name-col' },
  {
    field: 'Start Date',
    header: 'Date',
    class: 'text-no-wrap'
  },
  { field: 'HR', header: 'HR' },
  { field: 'InterviewRound', header: 'Interview Round' },
  { field: 'Status', header: 'Status', class: 'status' }
];

export const INTERVIEW_INVITATIONS_COLUMNS = [
  { field: 'CandidateName', header: 'Candidate Name', sortBy: 'FirstName', class: 'name-col' },
  { field: 'InterviewType', header: 'Technology' },
  { field: 'RoundOfInterview', header: 'Interview Round' },
  // { field: 'JobDesignation', header: 'Job Designation', class: 'text-no-wrap' },
  {
    field: 'Start Date',
    header: 'Interview Date',
    class: 'text-no-wrap text-bold interview-date',
    sortBy: 'StartDateOfInterviewRound'
  },
  { field: 'HrName', header: 'Hr Name' },
  { field: 'resume', header: 'Resume', isExport: false },
  { field: 'Status', header: 'Status', sortBy: 'Status', class: 'name-col' },
  // { field: 'Description', header: 'Description', class: 'description' },
  { field: 'action', header: 'Action', isExport: false }
];
export const INTERVIEW_FEEDBACK_COLUMNS = [
  { field: 'CandidateName', header: 'Candidate Name', sortBy: 'FirstName', class: 'name-col' },
  { field: 'InterviewType', header: 'Technology' },
  { field: 'RoundOfInterview', header: 'Interview Round' },
  { field: 'JobDesignation', header: 'Job Designation', class: 'text-no-wrap' },
  {
    field: 'StartDateOfInterviewRound',
    header: 'Start Date',
    sortBy: 'StartDateOfInterviewRound',
    class: 'text-no-wrap'
  },
  { field: 'action', header: 'Action' }
];

export const SCHEDULED_INTERVIEW_COLUMNS = [
  { field: 'CandidateName', header: 'Candidate Name', sortBy: 'FirstName', class: 'name-col' },
  { field: 'Technology', header: 'Technology' },
  { field: 'RoundOfInterview', header: 'Interview Round' },
  // { field: 'JobDesignation', header: 'Job Designation', class: 'text-no-wrap' },
  {
    field: 'Start Date',
    header: 'Interview Date',
    class: 'text-no-wrap text-bold interview-date',
    sortBy: 'StartDateOfInterviewRound'
  },
  { field: 'HrName', header: 'Hr Name' },
  { field: 'resume', header: 'Resume', isExport: false },
  // { field: 'Description', header: 'Description', class: 'description' },
  { field: 'action', header: 'Action', isExport: false }
];
export const HISTORY_INTERVIEW_COLUMNS = [
  { field: 'CandidateName', header: 'Candidate Name', sortBy: 'FirstName', class: 'name-col' },
  { field: 'Technology', header: 'Technology' },
  { field: 'RoundOfInterview', header: 'Interview Round' },
  { field: 'resume', header: 'Resume', isExport: false },
  // { field: 'JobDesignation', header: 'Job Designation', class: 'text-no-wrap' },
  {
    field: 'Start Date',
    header: 'Interview Date',
    class: 'text-no-wrap text-bold interview-date',
    sortBy: 'StartDateOfInterviewRound'
  },
  // { field: 'HrName', header: 'Hr Name',},
  { field: 'Status', header: 'Status', class: 'status' },
  // { field: 'Description', header: 'Description', class: 'description' },
  { field: 'action', header: 'Action', isExport: false }
];
export const INTERVIEWER = {
  SCHEDULED_INTERVIEW_COLUMNS: [
    { field: 'CandidateName', header: 'Candidate Name', class: 'name-col' },
    { field: 'InterviewType', header: 'Technology' },
    { field: 'RoundOfInterview', header: 'Interview Round' },
    // { field: 'JobDesignation', header: 'Job Designation', class: 'text-no-wrap' },
    {
      field: 'StartDateOfInterviewRound',
      header: 'Interview Date',
      class: 'text-no-wrap text-bold interview-date'
    },
    { field: 'HrName', header: 'Hr Name' },
    { field: 'resume', header: 'Resume', isExport: false },
    // { field: 'Description', header: 'Description', class: 'description' },
    { field: 'action', header: 'Action' }
  ],
  INTERVIEW_INVITATION_COLUMNS: [
    { field: 'CandidateName', header: 'Candidate Name', class: 'name-col' },
    { field: 'InterviewType', header: 'Technology' },
    { field: 'RoundOfInterview', header: 'Interview Round' },
    // { field: 'JobDesignation', header: 'Job Designation', class: 'text-no-wrap' },
    {
      field: 'StartDateOfInterviewRound',
      header: 'Interview Date',
      class: 'text-no-wrap text-bold interview-date'
    },
    { field: 'HrName', header: 'Hr Name' },
    { field: 'resume', header: 'Resume', isExport: false },
    { field: 'Status', header: 'Status', class: 'status' },
    // { field: 'Description', header: 'Description', class: 'description' },
    { field: 'action', header: 'Action' }
  ],
  FEEDBACK_COLUMNS: [
    { field: 'CandidateName', header: 'Candidate Name', class: 'name-col' },
    { field: 'InterviewType', header: 'Technology' },
    { field: 'RoundOfInterview', header: 'Interview Round' },
    { field: 'JobDesignation', header: 'Job Designation', class: 'text-no-wrap' },
    { field: 'StartDateOfInterviewRound', header: 'Start Date', class: 'text-no-wrap' },
    { field: 'action', header: 'Action' }
  ]
};

export const HR_FEEDBACK_HISTORY_COLUMNS = [
  { field: 'FieldName', header: 'Field Name' },
  { field: 'UpdatedValue', header: 'Feedback' },
  { field: 'OldValue', header: 'Old Feedback' },
  { field: 'InterviewRound', header: 'Interview Round' },
  { field: 'UpdatedBy', header: 'Updated By' },
  // { field: 'DateModified', header: 'Last modified', sortBy: 'DateModified', class: 'text-no-wrap' },
  { field: 'DateCreated', header: 'Date', class: 'text-no-wrap' }
];
